(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.section-header');
    this.mode = this.dataset.stickyType || 'none';
    this.lastY = window.pageYOffset || document.documentElement.scrollTop;

    this.setVars = this.setVars.bind(this);
    this.onScroll = this.onScroll.bind(this);

    this.setVars();
    window.addEventListener('resize', this.setVars);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (this.mode === 'always' || this.mode === 'reduce-logo-size') {
      this.section.classList.add('tp-sticky-active');
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.setVars);
    window.removeEventListener('scroll', this.onScroll);
  }

  setVars() {
    const h = this.offsetHeight || 0;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
    if (this.section) this.section.style.minHeight = `${h}px`;
  }

  onScroll() {
    if (!this.section || this.mode === 'none') return;

    const y = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = (this.offsetHeight || 0) + 20;

    if (this.mode === 'always' || this.mode === 'reduce-logo-size') {
      this.section.classList.add('tp-sticky-active');
      this.section.classList.remove('tp-sticky-hidden');
      if (y > 0) {
        this.section.classList.add('scrolled-past-header');
      } else {
        this.section.classList.remove('scrolled-past-header');
      }
      this.lastY = y;
      return;
    }

    if (y <= threshold) {
      this.section.classList.remove('tp-sticky-active', 'tp-sticky-hidden', 'scrolled-past-header');
      this.lastY = y;
      return;
    }

    this.section.classList.add('tp-sticky-active', 'scrolled-past-header');

    if (y < this.lastY) {
      this.section.classList.remove('tp-sticky-hidden');
    } else if (y > this.lastY) {
      this.section.classList.add('tp-sticky-hidden');
    }

    this.lastY = y;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
